'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tracking = tracking;
exports.track = track;

var _xr = require('xr');

var _xr2 = _interopRequireDefault(_xr);

var _getAppInfo2 = require('./getAppInfo');

var _postAndRetry = require('./postAndRetry');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function tracking(url) {
  return function (event, meta) {
    var retry = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var _getAppInfo = (0, _getAppInfo2.getAppInfo)(),
        tracking = _getAppInfo.tracking,
        instance = _getAppInfo.instance;

    if (tracking == null || instance == null) return;

    var payload = { event: event, tracking: tracking, game_instance: instance };

    if (meta) payload['meta'] = meta;

    if (retry) {
      (0, _postAndRetry.postAndRetry)(url, payload);
    } else {
      _xr2.default.post(url, payload).then(function (res) {}, function (res) {
        return console.error('tracking fail', res);
      });
    }
  };
}

var _track = tracking(window.TRACKING_URL);

function track(event, meta) {
  var retry = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (window.TRACKING_URL) _track(event, meta, retry);
}


//////////////////
// WEBPACK FOOTER
// ./~/dooh-utils/dist/tracking.js
// module id = 68
// module chunks = 0